import { Player } from '@anm/hosting-player';
import { useCallback } from 'react';

type HookProps = {
  player: Player | null;
  onRejected?: () => void;
};

const usePlayPause = ({ player, onRejected }: HookProps) => {
  const handleAutoplayRejected = useCallback(() => {
    if (!player) return;

    player.muted = true;

    player.play().catch(onRejected);
  }, [player, onRejected]);

  const play = useCallback(() => {
    if (!player || !player.source) {
      return;
    }

    player.play().catch(handleAutoplayRejected);
  }, [player, player?.source]);

  const pause = useCallback(() => {
    if (!player) return;

    player.pause();
  }, [player]);

  return [play, pause] as const;
};

export default usePlayPause;
